export const TYPES = {
  SET_FILE_TO_VIEW: "SET_FILE_TO_VIEW",
  SET_BLOB_LOCAL_URL: "SET_BLOB_LOCAL_URL",
  SET_CLEAR: "SET_CLEAR",
};
